export default __webpack_public_path__ + "static/media/dog.3a00415e.png";